import { KalturaLanguage } from '@kaltura-ott/ott-client-types/api/types';
import { AppLanguageCodes, PlayerLanguageCode } from '@kaltura-ott/tvpil';

import { alpha3LanguageHashMap } from './language.data';

export interface Language {
  id: number;
  name: string;
  code: string;
  direction: string;
  isDefault: boolean;
  nativeName: string;
  originCode: string;
  latinCode?: string;
  settingsNativeName?: string;
  playerMigrationKey?: string;
  migrationKey?: string;
}

export const formattedLanguageList = (
  languageList: KalturaLanguage[],
  playerLanguageCodes: PlayerLanguageCode[],
  appLanguageCodes: AppLanguageCodes,
): Language[] =>
  languageList.map(({ code, direction, id, isDefault, name }: KalturaLanguage) => ({
    id,
    name,
    isDefault,
    direction,
    // @ts-expect-error TODO Fix
    code: alpha3LanguageHashMap[code]?.alpha2,
    // @ts-expect-error TODO Fix
    nativeName: alpha3LanguageHashMap[code]?.nativeName,
    // @ts-expect-error TODO Fix
    settingsNativeName: alpha3LanguageHashMap[code]?.settingsNativeName,
    // @ts-expect-error TODO Fix
    latinCode: alpha3LanguageHashMap[code]?.latinCode,
    originCode: code,
    playerMigrationKey: playerLanguageCodes.find(
      // @ts-expect-error TODO Fix
      (playerLanguage) => playerLanguage.code === alpha3LanguageHashMap[code]?.alpha2,
    )?.key,
    migrationKey: Object.entries(appLanguageCodes).find(([key, value]) => value === code)?.[0],
  }));

/**
 * @param languages
 * @param translationLinks
 * @description filter language list by dms translation links [KUXEXT-9702]
 */
export const filterLanguageListByDmsTranslations = (
  languages: Language[],
  translationLinks: { [key: string]: string },
): Language[] => {
  const languageMap: Map<string, Language> = new Map();
  languages.forEach((language) => {
    language?.originCode && languageMap.set(language.originCode, language);
  });

  return Object.keys(translationLinks)
    .map((translationLinkKey) => {
      const splitLink = translationLinkKey.split('_');
      const languageCode = splitLink[splitLink.length - 1];
      return languageMap.get(languageCode);
    })
    .filter(Boolean) as Language[];
};
